import { Maybe } from '../entities/Maybe';

export default (value: Maybe<Partial<Interval>>): value is Interval => !!(value?.start && value.end);
